module.exports = __webpack_public_path__ + "static/img/cCT6.609ccaff.png";